import React, { useEffect, useState } from "react";

const VIDEOS = [
  {
    id: 1,
    title: "Séquence — Danse n°1",
    thumb: "/assets/thumb3.jpg",
    src: "rx-danseN°1.mp4",
    year: 2022,
    duration: "02:19",
  },
  {
    id: 2,
    title: "Installation — OOO-X-PO",
    thumb: "/assets/thumb2.jpg",
    src: "OOO-x-po.mp4",
    year: 2024,
    duration: "01:55",
  },
  {
    id: 3,
    title: "Séquence — Bad trip",
    thumb: "/assets/thumb3.jpg",
    src: "rx-badTrip.mp4",
    year: 2023,
    duration: "01:33",
  },
  {
    id: 4,
    title: "Séquence — cycle n°1",
    thumb: "/assets/thumb1.jpg",
    src: "reduxCycle1.mp4",
    year: 2025,
    duration: "02:39",
  },
  {
    id: 5,
    title: "Séquence — Mumbius",
    thumb: "/assets/thumb3.jpg",
    src: "rx-mumbius.mp4",
    year: 2024,
    duration: "02:42",
  },
  {
    id: 6,
    title: "Séquence — Cyberpunk",
    thumb: "/assets/thumb2.jpg",
    src: "Cyberpunk.mp4",
    year: 2023,
    duration: "03:31",
  },
   {
    id: 7,
    title: "Séquence — indusPrana",
    thumb: "/assets/thumb2.jpg",
    src: "rx-indusPrana.mp4",
    year: 2024,
    duration: "05:31",
  },
  {
    id: 8,
    title: "Restitution workshop — Lynch en scène(s)",
    thumb: "/assets/thumb2.jpg",
    src: "rx-lynch.mp4",
    year: 2025,
    duration: "02:07",
  },
];



export default function App() {
  const [active, setActive] = useState(null);

  // Fermer la modale sur ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setActive(null);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="site">
      {/* Header */}
      <header className="header">
        <div className="container header__inner">
          <div className="brand">
            <div>
              <h1 className="brand__title">bernard genin</h1>
              <p className="brand__subtitle">Artiste vidéo — installations & performances</p>
            </div>
          </div>
          <nav className="nav">
            <a href="#works">Œuvres</a>
            <a href="#about">À propos</a>
            <a href="#contact">Contact</a>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="hero" aria-label="Présentation">
        <video
          className="hero__video"
          src={VIDEOS[3].src}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="hero__overlay" />
        <div className="container hero__content">
          
         
        </div>
      </section>

      {/* Works */}
      <main className="container main">
        <section id="works" className="section">
          <h3 className="section__title">Sélection de pièces et performances</h3>
          <div className="grid">
            {VIDEOS.map((v) => (
              <article key={v.id} className="card">
                <button className="card__thumb" onClick={() => setActive(v)}>
                  <img src={v.thumb} alt={v.title} />
                  <span className="card__play" aria-hidden>▶</span>
                </button>
                <div className="card__body">
                  <h4 className="card__title">{v.title}</h4>
                  <p className="card__meta">{v.year} • {v.duration}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        {/* Modal player */}
        {active && (
          <div className="modal" role="dialog" aria-modal="true" aria-label={active.title}>
            <div className="modal__panel">
              <div className="modal__bar">
                <h5 className="modal__title">{active.title}</h5>
                <div className="modal__actions">
                  <a className="link" href={active.src} target="_blank" rel="noreferrer">Ouvrir la source</a>
                  <button className="link" onClick={() => setActive(null)}>Fermer ✕</button>
                </div>
              </div>
              <video src={active.src} controls autoPlay className="modal__video" />
              <div className="modal__notes">
                
              </div>
            </div>
          </div>
        )}

        {/* About */}
        <section id="about" className="section layout">
          <div className="layout__main">
            <h3 className="section__title">À propos</h3>
            <p>
              Bernard Genin développe son travail au croisement de la performance, de l’installation et du cinéma expérimental.
              </p>  <p>Artiste multidisciplinaire, il associe son expérience des arts de la scène et des arts numériques 
              pour créer des œuvres qui expriment un engagement critique face au consumérisme et au techno-optimisme. </p>
               <p> Utilisant projections, captation en temps réel des sons et traitement visuel, 
              il explore des formes hybrides, où le théâtre, la musique et l’image dialoguent, se confrontent et se transforment mutuellement. </p>
             
            
            
          </div>
          
        </section>

      {/* Contact */}
        <section id="contact" className="section box">
          <h3 className="section__title">Contact</h3>
         
          <div className="cols cols--split">
            <form className="form" onSubmit={(e) => e.preventDefault()}>
              <input className="input" placeholder="Votre nom" />
              <input className="input" placeholder="Email" />
              <input className="input" placeholder="Sujet" />
              <textarea className="input input--area" placeholder="Message" />
              <button className="btn">Envoyer</button>
            </form>
            
          </div>
        </section>

        <footer className="footer">© {new Date().getFullYear()} bernard genin — Tous droits réservés</footer>
      </main>
    </div>
  );
}
